import { VITE_CONTACT_EMAIL } from '@/shared/lib/env';

type MailTemplate = {
  subject: string;
  body: string[];
};

type BuildMailtoHrefOptions = {
  /** 件名の先頭に付与するプレフィックス（例: "[DEV] "） */
  subjectPrefix?: string;
  /** テンプレート内のプレースホルダーを置換するための値 */
  replacements?: Record<string, string>;
};

/**
 * メールテンプレートから mailto リンクを生成する
 *
 * replacements に指定した値でテンプレート内の {{key}} プレースホルダーを置換する
 */
export const buildMailtoHref = (
  template: MailTemplate,
  { subjectPrefix = '', replacements = {} }: BuildMailtoHrefOptions = {},
): string => {
  const subject = encodeURIComponent(`${subjectPrefix}${template.subject}`);

  let bodyText = template.body.join('\n');
  for (const [key, value] of Object.entries(replacements)) {
    bodyText = bodyText.replaceAll(`{{${key}}}`, value);
  }

  const body = encodeURIComponent(bodyText);
  return `mailto:${VITE_CONTACT_EMAIL}?subject=${subject}&body=${body}`;
};
